import Fallback from "app/components/Fallback";
import React from "react";

const Notice = React.lazy(() =>
  import("app/modules/communication/pages/NoticeBoard")
);

const TextSMS = React.lazy(() =>
  import("app/modules/communication/pages/TextSMS")
);

const WhatsApp = React.lazy(() =>
  import("app/modules/communication/pages/whatsApp/WhatsApp")
);

export const NoticeBoardPage = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <Notice {...props} />
  </React.Suspense>
);

export const TextSMSPage = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <TextSMS {...props} />
  </React.Suspense>
);
export const WhatsAppPage = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <WhatsApp {...props} />
  </React.Suspense>
);
